import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJpFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53535)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M49.1383 41.3792H0.862596C0.386523 41.3792 0.000488281 40.9932 0.000488281 40.5171V9.48271C0.000488281 9.00664 0.386523 8.62061 0.862596 8.62061H49.1384C49.6145 8.62061 50.0005 9.00664 50.0005 9.48271V40.5171C50.0004 40.9933 49.6144 41.3792 49.1383 41.3792Z",
				fill: "#F3F3F3"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M25.0005 34.4824C30.2375 34.4824 34.4829 30.237 34.4829 25C34.4829 19.763 30.2375 15.5176 25.0005 15.5176C19.7635 15.5176 15.5181 19.763 15.5181 25C15.5181 30.237 19.7635 34.4824 25.0005 34.4824Z",
				fill: "#CD343C"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53535",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgJpFlag);
export { ForwardRef as ReactComponent };
